import React, { useState } from "react";
import "./BrowseGrid.css";
import "./BrowseCard.scss";
import { Link } from  "react-router-dom";
import useToast from "../hooks/useToast";
import { fetchFundSubcategory } from "../services/funds.service";

function AreasOfNeed({
  setCategoryInfo,
  setBreadcrumbs,
  search,
  subcategories,
  setSubcategories,
  fundCategoryId,
}) {
  const [isLoadingSubcategories, setIsloadingSubcategories] = useState(false);
  const notifyGetFundSubCategoryError = useToast({
    type: "error",
    id: `fundCategory${fundCategoryId}`,
    actionText: "RETRY?",
    action: async () => await getFundSubCategory(),
    dismissable: true,
    message: `There was a problem loading fund category ${fundCategoryId}.`,
  });

  function getFundSubCategory() {
    return fetchFundSubcategory(fundCategoryId)
      .then(async (response) => {
        const listSubcategories = response;
        setSubcategories(listSubcategories.results);
        setBreadcrumbs(listSubcategories.breadcrumbs);
        setCategoryInfo(listSubcategories.category_info);
        return response;
      })
      .catch(() => {
        notifyGetFundSubCategoryError();
      })
      .finally(() => {
        setIsloadingSubcategories(false);
        return true;
      });
  }

  React.useEffect(() => {
    if (!isLoadingSubcategories) {
      setIsloadingSubcategories(true);
      getFundSubCategory();
    }
  }, [fundCategoryId]);

  const renderSubcategories = () =>
    subcategories.map((subcategory, index) => {
      const inlineStyle = subcategory?.image
        ? {
            backgroundImage: `url(${subcategory.image})`,
          }
        : {};

      return (
        <div
          className="browse__grid-item browse__grid-item--category"
          key={"subcategory-item-" + index}
        >
          <Link
            data-hook="fund-category"
            className={`browse-card browse-card--category ${
              subcategory?.image ? "has-background-image" : ""
            }`}
            style={inlineStyle}
            to={subcategory.link}
            state={{ catId: subcategory.tid }}
          >
            <div className="browse-card__inner browse-card__inner--category">
              <h3 className="browse-card__title browse-card__title--category">
                <span dangerouslySetInnerHTML={{ __html: subcategory.name }} />
              </h3>
              <div className="browse-card__actions browse-card__actions--category">
                <span className="browse-card__button browse-card__button--category coh-style-link-with-icon">
                  View Funds
                </span>
              </div>
            </div>
          </Link>
        </div>
      );
    });

  return (
    <>
      {subcategories.length > 0 && !search ? (
        <div
          className="browse__wrapper browse__wrapper--categories"
          id="subcategories"
        >
          <h2 className="browse__title browse__title--categories">
            Areas of Need
          </h2>
          <div className="browse__grid browse__grid--categories">
            {renderSubcategories()}
          </div>
        </div>
      ) : null}
    </>
  );
}

export default AreasOfNeed;
